<!--
FILTROS
-->
<p-sidebar [(visible)]="displayFilters" styleClass="ui-sidebar-md" position="left">
  <h2><i class="fas fa-search" aria-hidden="true"></i> {{ 'DocumentsSearch.title' | translate }}</h2>
  <hr>
  <div class="float-right">
    <button (click)=" updateFiltersAndLoadDocuments ()" class="btn btn-primary mr-1" id="_searchButton"><i
        class="fas fa-search mr-1"></i>{{'General.search.text' | translate}}</button>
    <button (click)=" switchFilters ()" class="btn btn-secondary"><i class="fas fa-close mr-1"></i>{{'General.cancel'
      |translate}}</button>
  </div>
  <p-scrollPanel [style]="{width: '100%', height: '90vh'}" styleClass="custombar1">
    <div style="margin-right: -15px; margin-top: -40px;">
      <form (keyup.enter)="updateFiltersAndLoadDocuments ()">
        <div #formContainer></div>
      </form>
    </div>
  </p-scrollPanel>
</p-sidebar>
<div class="wrapper wrapper-content animated fadeInRight">
  <div class="container-fluid ">
    <ng-container *ngIf="loaded">
      <ng-container *ngIf="error; else documentsTpl">
        <ng-container *ngTemplateOutlet="errorTpl"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
<ng-template #documentsTpl>
  <ng-container *ngIf="searchPerformed; else noSearchPerformed">
    <ng-container *ngTemplateOutlet="searchResult"></ng-container>
  </ng-container>
</ng-template>
<ng-template #searchResult>
  <!-- NUMERO DE DOCUMENTOS VISIBLES Y TOTALES -->
  <div *ngIf="(documents && documents.length > 0)" class="row m-t-xs">
    <div class="col-12">
      <span class="float-right leyenda">{{ 'Tasks.showing' | translate }} {{ documents ? documents.length : '0' }} de {{
        state.pageInfo.totalElements }} </span>
    </div>
  </div>
  <!-- FILTROS -->
  <div class="row  filterHeader m-t-sm " *ngIf="activeFilters.length > 0">
    <div class="col-12">
      <ng-container *ngFor="let filter of activeFilters">
        <span (click)="removeFilter(filter)">
          <a class="btn btn-filter btn-xs m-xs"> {{ filter.label }} <span *ngIf="filter.value !== true">= {{
              filter.value }}</span>
            <i class="fas fa-times ml-1" aria-hidden="true"></i>
          </a>
        </span>
      </ng-container>
    </div>
  </div>
  <!-- DOCUMENTOS -->
  <ng-container *ngIf="(documents && documents.length > 0); else noResults">
    <div class="row">
      <div class="col-12">
        <p-table #dt [value]="documents" class="footer-over-pagination" [scrollable]="false" [resizableColumns]="true"
          class="footer-over-pagination" [paginator]="true" [pageLinks]="5"
          [first]="state.pageInfo.number * state.pageInfo.size" [rows]="state.pageInfo.size" dropdownAppendTo="body"
          [totalRecords]="state.pageInfo.totalElements" [rowsPerPageOptions]="[10, 25, 50, 100]" [lazy]="true"
          (onLazyLoad)="customSort($event)" [autoLayout]="true" (onPage)="loadPaginatedDocuments ($event)">
          <ng-template pTemplate="header">
            <tr>
              <th class="text-ellipsis" ttResizableColumn> Nombre </th>
              <th [pSortableColumn]="'contractFolderId'"> {{ 'DossiersView.id.dossier' | translate }} <p-sortIcon
                  [field]="'contractFolderId'"></p-sortIcon>
              </th>
              <th class="d-none d-md-table-cell" ttResizableColumn> {{ 'Documents.date' | translate }} </th>
              <!-- <th class="d-none d-md-table-cell text-ellipsis" ttResizableColumn>
              Tipo
            </th> -->
              <th class="d-none d-lg-table-cell" ttResizableColumn> {{ 'Documents.state' | translate }} </th>
              <th class="text-center action-column"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-doc>
            <tr>
              <td class="text-ellipsis ">
                <!-- descripcion de documento -->
                <span [pTooltip]="this.getDocTooltip(doc)" class="doc-name">
                  <i class="far fa-file-alt px-1 fa-1-5x" aria-hidden="true"></i>{{ doc.name }} </span>
              </td>
              <td>
                <divisionDetail [project]="doc.entity.division.project" [infoLink]="true" [infoTitulo]="false"
                  class="d-inline">
                </divisionDetail>
              </td>
              <td class="d-none d-md-table-cell">
                <span *ngIf="doc"> {{ doc.date | date: 'dd/MM/yyyy HH:mm' }}</span>
              </td>
              <!-- tipo de documento -->
              <!-- <td class="d-none d-md-table-cell text-ellipsis ">
              <span [pTooltip]="this.getDocTooltip(doc)" class="doc-name">
                {{ doc.entity.documentClass.name }}
              </span>
            </td> -->
              <td class="d-none d-md-table-cell">
                <span class="p-1 w-100 text-truncate font-weight-normal"
                  [ngClass]="documentService.getStatusColor(doc.currentState)" *ngIf="isValidState (doc)"> {{
                  doc.currentState.type.description }} </span>
              </td>
              <!-- BOTONERA -->
              <td class="text-rigth action-column">
                <!-- <documentsActions *ngIf="doc" [doc]="doc"></documentsActions> -->
                <div class="btn-group">
                  <!-- <button class="btn  btn-primary btn-sm t-action-button"
                    [routerLink]="['/documentViewer', doc.identifier]" title="{{ 'General.visualize' | translate}}">
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </button> -->
                  <button class="btn  btn-primary btn-sm" style="min-height: 25px;" (click)="openDocument (doc)"
                    title="{{ 'General.visualize' | translate}}">
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </button>
                </div>
                <!-- <button class="btn  btn-primary btn-sm t-action-button" title="{{ 'General.select' | translate}}"
                  (click)="selectDocument(doc)" *ngIf="isModalWindow && doc">
                  <i class="fas fa-check" aria-hidden="true"></i>
                </button> -->
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-container>
</ng-template>
<ng-template #noSearchPerformed>
  <div class="jumbotron jumbotron-fluid" onmouseover="" style="cursor: pointer;" (click)="switchFilters ()">
    <div class="container">
      <h1><span><i class="fas fa-search mr-1"></i>{{ 'DocumentsSearch.stateNoSearch' | translate}}</span></h1>
      <p>{{ 'DocumentsSearch.stateNoSearchMsg' | translate}}</p>
    </div>
  </div>
</ng-template>
<ng-template #noResults>
  <div class="jumbotron jumbotron-fluid mt-3">
    <div class="container">
      <h1><span><i class="fas fas-empty mr-1"></i>{{ 'DocumentsSearch.stateNoDataFound' | translate}}</span></h1>
    </div>
  </div>
</ng-template>
<ng-template #errorTpl>
  <div class="jumbotron jumbotron-fluid bg-danger text-white" (click)="switchFilters ()">
    <div class="container">
      <h1><span><i class="fas fa-exclamation-circle mr-1" aria-hidden="true"></i>{{ 'DocumentsSearch.stateError' |
          translate}}</span></h1>
    </div>
  </div>
</ng-template>